import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import { BuildingProvider } from './contexts/BuildingContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './components/Layout/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FaultReports from './pages/FaultReports';
import FaultReportDetail from './pages/FaultReportDetail';
import Forum from './pages/Forum';
import TopicDetail from './pages/TopicDetail';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';
import PropertySetup from './pages/PropertySetup';
import Announcements from './pages/Announcements';
import Settings from './pages/Settings';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <BuildingProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              
              {/* Protected Routes */}
              <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                {/* Base Routes - Available to all authenticated users */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/fault-reports" element={<FaultReports />} />
                <Route path="/fault-reports/:id" element={<FaultReportDetail />} />
                <Route path="/forum" element={<Forum />} />
                <Route path="/forum/:topicId" element={<TopicDetail />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/profile" element={<Profile />} />
                
                {/* Settings - Manager and above */}
                <Route
                  path="/settings"
                  element={
                  <ProtectedRoute requireSettings>
                      <Settings />
                    </ProtectedRoute>
                  } />

                
                {/* User Management - Superadmin and Administrator only */}
                <Route
                  path="/user-management"
                  element={
                  <ProtectedRoute requireUserManagement>
                      <UserManagement />
                    </ProtectedRoute>
                  } />

                
                {/* Property Setup - Superadmin and Administrator only */}
                <Route
                  path="/property-setup"
                  element={
                  <ProtectedRoute requirePropertySetup>
                      <PropertySetup />
                    </ProtectedRoute>
                  } />

                
                {/* Announcements - Manager and above */}
                <Route
                  path="/announcements"
                  element={
                  <ProtectedRoute requireSettings>
                      <Announcements />
                    </ProtectedRoute>
                  } />


              </Route>
              
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Toaster position="top-right" richColors />
          </BuildingProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>);

}

export default App;